import React, { useState } from "react";
import { AgChartsReact } from "ag-charts-react";
// import { Pie } from "@ant-design/plots";
const Piechart = () => {
  const [options] = useState({
    data: [
      { asset: "Stocks", amount: 22 },
      { asset: "Bonds", amount: 11 },
      { asset: "Cash", amount: 21 },
      { asset: "Real Estate", amount: 43 },
      { asset: "Commodities", amount: 7 },
    ],
    title: {
      text: "Frequently used goals",
    },
    series: [
      {
        fills: ["lightBlue", "green", "yellow", "orange"],
        type: "pie",
        angleKey: "amount",
        calloutLabelKey: "asset",
        sectorLabelKey: "amount",
        showInLegend: false,
        sectorLabel: {
          color: "white",
          fontWeight: "bold",
          formatter: ({ value }) => `${value}`,
        },
      },
    ],
    // series: [
    //   {
    //     fills: ["lightBlue", "green", "yellow", "orange"],
    //     type: "pie",
    //     angleKey: "amount",
    //     legendItemKey: "asset",
    //     sectorLabel: {
    //       color: "white",
    //       fontWeight: "bold",
    //       formatter: ({ value }) => `$${(value / 1000).toFixed(0)}K`,
    //     },
    //     showInLegend: false,
    //     formatter: ({ value }) => `$${(value / 1000).toFixed(0)}K`,
    //   },
    // ],
  });
  // return <Pie {...config} />;
  return <AgChartsReact options={options} />;
};

export default Piechart;
